// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1p6Ty","rootNoMargin":"styles_rootNoMargin__4y7Fz"};